module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/street-55.c45323ec.png";